import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { OutlinedButton } from './components'
import { SxProps } from '@material-ui/system'
import { Box, Divider } from '@material-ui/core'
import { AuthTemplateView, ResetPasswordTokenContainer } from '~/components'

const styles: Record<string, SxProps> = {
  divider: {
    marginTop: 4,
    color: 'GrayText'
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    marginTop: 4
  }
}

export const ExpiredLink: React.FC = () => {
  const [isResendOfTokenSuccessful, setIsResendOfTokenSuccessful] = useState(false)

  const history = useHistory()

  if (isResendOfTokenSuccessful) {
    return (
      <AuthTemplateView
        title='Solicitação enviada'
        description='Recebemos sua solicitação. Se existir um cadastro com este CNPJ, você receberá uma e-mail com instruções para a recuperação de senha! Não se esqueça de verificar a caixa de spam.'
        onBackButtonClick={() => history.push('/')}
      />
    )
  }

  return (
    <ResetPasswordTokenContainer
      title='Link expirado'
      description='Este link de recuperação de senha expirou. Informe o CNPJ da sua empresa para receber um novo link por email e cadastrar uma nova senha.'
      hideLinkToCreateNewAccount
      onBackButtonClick={() => history.push('/')}
      setSuccessfulOperation={setIsResendOfTokenSuccessful}
      afterFormChildren={(
        <>
          <Divider sx={styles.divider}>OU</Divider>
          <Box sx={styles.box}>
            <OutlinedButton href='/'>Entrar na minha conta</OutlinedButton>
            <OutlinedButton href='/register'>Fazer meu cadastro</OutlinedButton>
          </Box>
        </>
      )}
    />
  )
}
